// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1lFkd","header":"MergedInvoice_header__VfkqR"};